import React from "react";
import { styled as muiStyled } from "@mui/material/styles";

import ProductSuggestion from "./ProductSuggestion/ProductSuggestion";
import BannerDesktop from "./Banner/BannerDesktop";
import BannerMobile from "./Banner/BannerMobile";
import BannerPopup from "./Banner/BannerPopup";
import BlogSuggestion from "./BlogSuggestion/BlogSuggestion";
import Features from "./Features/Features";
import Categories from "./Categories/Categories";
import Section from "./Section/Section";
import MetaTag from "./Metatag/Metatag";
import SuitableAreaRoom from "./SuitableAreaRoom/SuitableAreaRoom";
import BrandPromotion from "./BrandPromotion/BrandPromotion";
import ShopThisMoodBannerHome from "./ShopThisMood/BannerHome";
import PopularSeller from "./PopularSeller/PopularSeller";

const drawerWidth = 260;

const Main = muiStyled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  width: "100%",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
    width: `calc(100% - ${drawerWidth}px)`,
  }),
}));

const DrawerHeader = muiStyled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function LandingPage({ open }) {
  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <Section />
        <Categories />
        <MetaTag />
        <BannerDesktop />
        <BannerMobile />
        <BannerPopup />
        <Features />
        <SuitableAreaRoom />
        <BrandPromotion />
        <ProductSuggestion />
        <ShopThisMoodBannerHome />
        <BlogSuggestion />
        <PopularSeller />
      </Main>
    </>
  );
}

export default LandingPage;
